<template lang="pug">
//- 篩選組件
.filter-com
  .filter-title.title-style 篩選
  .language(
    v-if="main_types.length",
    v-bind:class="use_type === 'history' ? 'float-left' : ''"
  )
    .filter-sm-title.sm-title-style 
      span(v-if="base_sources.indexOf(use_type) > -1") 語言
      span(v-else) 主要類別
    //- 語言別
    .language-box
      .language-filter
        .filter-item.click-cursor(
          v-for="type in main_types",
          v-bind:class="[language_filter === type.id ? 'bg-blue-1' : 'bg-gray-1']",
          @click="clickLanFilter(type.id)"
        ) {{ type.name }}
        .clearfix

  .crouse(
    v-if="sub_types.length",
    v-bind:class="use_type === 'history' ? 'float-left' : ''"
  )
    .filter-sm-title.sm-title-style 
      span(v-if="base_sources.indexOf(use_type) > -1") 班別
      span(v-else) 次要類別
    //- 班別
    .class-box
      .class-filter
        .filter-item.click-cursor(
          v-for="type in sub_types",
          v-bind:class="[class_filter === type.id ? 'bg-blue-1' : 'bg-gray-1']",
          @click="clickClassFilter(type.id)"
        ) {{ type.name }}
        .clearfix
  .clearfix
</template>
<script>
import $ from 'jquery'
export default {
  name: 'filterCom',
  props: ['language_filter', 'class_filter', 'use_type'],
  components: {},
  data () {
    return {
      course_langs: [],
      course_types: [],
      allow_other: ['home', 'history'],
      main_types: [
        { id: "all", name: "全部" },
      ],
      sub_types: [
        { id: "all", name: "全部" },
      ],
      base_sources: ["new", "home", "group", "history"]
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    language_filter (_mainType) {
      // 如果來源在兒少，就重新設置類別
      if (this.use_type === 'children') {
        this.processChildrenOptions()
      }
    }
  },
  async created () {
    // 呼叫篩選元件
    console.log('來源屬性: ', this.use_type)

    setTimeout(() => { this.processStartView() }, 250)
  },
  methods: {
    async processStartView () {
      // 清空選項
      if (this.allow_other.indexOf(this.use_type) > -1) {
        this.sub_types = [{ id: "all", name: "全部" }]
      }

      // 針對來源處理需要顯示的類別
      switch (this.use_type) {
        // 原來的類別方式
        case 'new':
        case 'home':
        case 'group':
        case 'history':
          await this.processLanguageOptions()
          break;

        // 精彩選播
        case 'highlight':
          await this.processHighlightOptions()
          break;

        // 高中英語
        case 'senior':
          await this.processSeniorOptions()
          break;

        // 國中英語
        case 'junior':
          await this.processJuniorOptions()
          break;

        // 兒少專區
        case 'children':
          await this.processChildrenOptions()
          break;
      }
    },
    clickLanFilter (_langID) {
      this.$emit('setLang', _langID)
    },
    clickClassFilter (_courseType) {
      this.$emit('setCourse', _courseType)
    },
    // 針對來源處理語言選項
    async processLanguageOptions () {
      var vm = this

      // 對團班進行特殊處理
      if (this.use_type === 'group') {
        // this.sub_types = []
        await this.clickClassFilter("all")
      }

      // 若非全系統課表開放時
      if (!this.$root.isAllOpen) {
        // 獲取該學員准許使用的課程類型
        await this.$root.user.course_types.forEach(async function (_courseType) {
          await vm.$root.total_course.forEach(async function (_item) {
            // 處理課表頁面
            if (vm.allow_other.indexOf(vm.use_type) > -1) {
              if (_item.id === _courseType) {
                await vm.sub_types.push(_item)
              }
            }
            // 處理團班頁面
            if (vm.use_type === 'group') {
              if (_item.id !== 'PS' && _item.id === _courseType) {
                await vm.sub_types.push(_item)
              }
            }
          })
        })

        // 獲取該學員准許使用的課程語言
        await this.$root.user.coures_langs.forEach(async function (_courseLang) {
          await vm.$root.total_langes.forEach(async function (_item) {
            if (_item.id === _courseLang) {
              await vm.main_types.push(_item)
            }
          })
        })
      }

      // 若為全系統課表開放時
      else {
        await vm.$root.total_course.forEach(async function (_item) {
          // 處理課表頁面
          if (vm.allow_other.indexOf(vm.use_type) > -1) {
            await vm.sub_types.push(_item)
          }
          // 處理團班頁面
          if (vm.use_type === 'group') {
            if (_item.id !== 'PS') {
              await vm.sub_types.push(_item)
            }
          }
        })
        await vm.$root.total_langes.forEach(async function (_item) {
          await vm.main_types.push(_item)
        })
      }
    },
    // 針對精彩選播處理類別內容
    async processHighlightOptions () {
      let mainOptions = [
        { id: 1, name: "時尚美語" },
        { id: 2, name: "生活美語" },
        { id: 3, name: "時尚日語" },
        { id: 4, name: "生活日語" },
        { id: 5, name: '超優快訊' },
        { id: 6, name: 'M Milton' }
      ]

      let subOptions = [
        { id: 1, name: "旅學文化" },
        { id: 2, name: "國際時事" },
        { id: 3, name: "生活健康" },
        { id: 4, name: "時尚娛樂" },
        { id: 5, name: "商業財經" },
        { id: 6, name: '科技知識' }
      ]

      var vm = this
      await mainOptions.forEach(async function (_item) {
        await vm.main_types.push(_item)
      })
      await subOptions.forEach(async function (_item) {
        await vm.sub_types.push(_item)
      })

      // 處理點擊功能
      setTimeout(() => { $('.language-filter').css({ 'width': this.main_types.length * 6 + 'rem' }) }, 20);
      setTimeout(() => { $('.class-filter').css({ 'width': this.sub_types.length * 6 + 'rem' }) }, 20);
    },
    // 針對處理類別內容
    async processSeniorOptions () {
      let mainOptions = [
        { id: 1, name: "單字片語" },
        { id: 2, name: "聽力" },
        { id: 3, name: "文法" },
        { id: 4, name: "克漏字" },
        { id: 5, name: "閱讀" },
        { id: 6, name: "翻譯寫作" }
      ]

      var vm = this
      await mainOptions.forEach(async function (_item) {
        await vm.main_types.push(_item)
      })

      this.sub_types = []

      // 處理點擊功能
      setTimeout(() => { $('.language-filter').css({ 'width': this.main_types.length * 6 + 'rem' }) }, 20);
    },
    // 針對處理類別內容
    async processJuniorOptions () {
      let mainOptions = [
        { id: 1, name: "單字片語" },
        { id: 2, name: "聽力" },
        { id: 3, name: "文法" },
        { id: 4, name: "克漏字" },
        { id: 5, name: "閱讀" }
      ]

      var vm = this
      await mainOptions.forEach(async function (_item) {
        await vm.main_types.push(_item)
      })

      this.sub_types = []

      // 處理點擊功能
      setTimeout(() => { $('.language-filter').css({ 'width': this.main_types.length * 6 + 'rem' }) }, 20);
    },
    // 針對處理類別內容
    async processChildrenOptions () {
      // let mainOptions = [
      //   { id: 1, name: "兒少美語" },
      //   { id: 2, name: "兒少日語" },
      // ]

      let subOptions = []
      subOptions[1] = [
        { id: 1, name: "KK音標" },
        { id: 2, name: "Starter" },
        { id: 3, name: "課本" },
        { id: 4, name: "讀本" },
        { id: 5, name: "單字" }
      ]
      subOptions[2] = [
        { id: 1, name: "50音" },
        { id: 2, name: "課本" },
        { id: 3, name: "字彙" }
      ]

      this.main_types = []
      this.sub_types = [{ id: "all", name: "全部" }]

      var vm = this
      // await mainOptions.forEach(async function (_item) {
      //   await vm.main_types.push(_item)
      // })

      if (this.language_filter === 1) {
        await subOptions[1].forEach(async function (_item) {
          await vm.sub_types.push(_item)
        })
      }

      if (this.language_filter === 2) {
        await subOptions[2].forEach(async function (_item) {
          await vm.sub_types.push(_item)
        })
      }

      // 設置預選項目
      if (!this.language_filter) {
        await this.clickLanFilter(1)
      }
      await this.clickClassFilter('all')

      // 處理點擊功能
      setTimeout(() => { $('.language-filter').css({ 'width': this.main_types.length * 6 + 'rem' }) }, 20);
      setTimeout(() => { $('.class-filter').css({ 'width': this.sub_types.length * 6 + 'rem' }) }, 20);
    }
  }
}
</script>
<style lang="sass" scoped>
.filter-com
  width: 100%
  margin: .2rem 0 0 0
  overflow: hidden
  .language
    margin-right: 2rem
  .language-box
    padding-left: .2rem
    width: 100%
    overflow: auto
  .language-filter
    width: 40rem
    overflow: auto
  .filter-sm-title
    margin: .55rem 0 .1rem 0
  .class-box
    padding-left: .2rem
    width: 100%
    overflow: auto
    .class-filter
      width: 40rem

  .filter-item
    float: left
    height: 2.6rem
    line-height: 2.6rem
    margin-right: .5rem
    border-radius: 5px
    padding: 0 1.3rem
    font-size: .7rem
    font-weight: 500
    text-align: center
    &:active
      opacity: .6
  .bg-blue-1
    background: #2e50ff
    color: #fff
    font-size: .8rem
  .bg-gray-1
    background: #f3f3f3
    color: #91a1c1
</style>
